<template>
    <div>
        <table class="table">
            <thead class="text-uppercase fs-12">
                <tr>
                    <th  v-if="child">#</th>
                    <th>{{ trans('general.page.space_billing.payment.model.invoices') }}</th>
                    <th class="text-end">{{ trans('general.page.space_billing.invoice.model.amount') }}</th>
                </tr>
            </thead>
            <tbody class="text-dark mt-3">
            <tr class="invoice-item fs-14" v-if="child" v-for="invoice in invoices" @click="check(invoice)">
                <td class="">
                    <div class="form-check">
                        <input class="form-check-input"  type="checkbox" :value="invoice.id" v-model="selectedIds">
                    </div>
                </td>
                <td class="">
                    <div><b>{{ invoice.sequence }} </b></div>
                    <small>{{ invoice.issue_date }}</small>
                </td>
                <td class="text-end">
                    <div class="text-end text-success " v-if="isInvoiceSelected(invoice)">
                        {{ getCurrency(invoice) }} {{round(getInvoicePayingAmount(invoice) / 100, 2).toFixed(2) }}
                    </div>
                    <span class="text-end d-inline-block text-secondary ">
                        {{ getCurrency(invoice) }} {{round((invoice.open_balance - getInvoicePayingAmount(invoice)) / 100, 2).toFixed(2) }}
                    </span>
                </td>
            </tr>
            <tr class="invoice-item fs-14" v-if="payment" v-for="invoice in invoices">
                <td class="">
                    <div><b>{{ invoice.sequence }} </b></div>
                    <span class="badge" :class="statusStyle(invoice.status).badge">{{ transStatus(invoice.status) }}</span>
                </td>
                <td class="text-end">
                      <div class="text-end  d-inline-block">
                        <span class="text-success">{{ getCurrency(invoice) }} {{ round(invoice.pivot.amount_paid / 100, 2).toFixed(2) }}</span>
                        <small class="text-dark d-block">
                          {{ round(invoice.amount / 100, 2).toFixed(2) }}
                        </small>
                    </div>
                </td>
            </tr>
            <tr class="invoice-item fs-14" v-if="invoices.length === 0">
                <td class="text-center fw-bold text-gray-700 " colspan="3">
                    {{trans('general.page.space_billing.invoice.messages.child_has_no_open_invoice')}}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import WaitingIndicatorIcon from "../../../theme/atoms/WaitingIndicatorIcon.vue";
import {
    BADGE_STYLES,
    DEFAULT_STATUS_STYLES, EMIT_SELECTED_INVOICES, getSpaceCurrency,
    STATUS_OPEN,
    statusStyle,
    transStatus
} from "../../../services/SpaceBillingContants";
import {round} from "../../../services/MathFunctions";
const LOAD_INVOICES = 'LOAD_INVOICES'
export default {
    name: "PayableInvoicesList",
    props: {
        payment: Object,
        child: Object,
        payableAmount: Number
    },
    components: {
        WaitingIndicatorIcon
    },
    data() {
        return {
            page:  1,
            limit:  3,
            total: 0,
            invoices: [],
            statusStyles: DEFAULT_STATUS_STYLES,
            badgeStyles: BADGE_STYLES,
            LOAD_INVOICES,
            selectedInvoices: [],
            selectedIds: [],
            currency: null
        }
    },
    computed: {
        availableAmount: function () {
            if (!this.payableAmount) return 0;

            return (this.payableAmount * 100) - this.amountUsed;
        },

        amountUsed: function () {
            let amountUsed = 0;

            this.selectedInvoices.forEach(invoice => {
                amountUsed = amountUsed + invoice.amount_paid
            });

            return amountUsed;
        }
    },
    watch: {
        child: {
            handler: function (val) {
                this.selectedInvoices = [];
                this.selectedIds = [];
                this.reload();
            },
            deep: true
        },
        selectedInvoices: function (val) {
            this.$emit(EMIT_SELECTED_INVOICES, val)
        }
    },
    methods: {
        round: round,
        statusStyle:statusStyle,
        transStatus: transStatus,
        getCurrency(invoice) {
            return invoice?.currency?.symbol ?? this.currency?.symbol
        },
        async load() {
            this.$wait.start(LOAD_INVOICES);

            const params = {
                limit: this.limit, page: this.page,
                order_by: 'issue_date;id',
                sorted_by: 'DESC',
                status: STATUS_OPEN,
                childId: this.child.id
            };
            const response = await axios.get(`/space/billing/invoices`, {params});
            this.invoices = response.data.data.data ;

            this.$wait.end(LOAD_INVOICES);
        },
        async loadPaidInvoices() {
            this.$wait.start(LOAD_INVOICES);

            const params = {include: 'invoices'};
            const response = await axios.get(`/space/billing/payments/read/${this.payment.id}`, {params});

            this.invoices = response.data.data.invoices ;

            this.$wait.end(LOAD_INVOICES);
        },
        showMore() {
            this.pageNum = this.pageNum + 1;
            this.load()
        },
        reload() {
            this.page = 1;
            this.load();
        },

        check(invoice) {
            if (!this.isInvoiceSelected(invoice) && !this.availableAmount) {
                return;
            }

            this.isInvoiceSelected(invoice)
                ? this.selectedIds = this.selectedIds.filter(v => v !== invoice.id) : this.selectedIds.push(invoice.id);

            this.selectedInvoices = [];
            this.invoices.forEach(invoice => {
                if (this.isInvoiceSelected(invoice)) {
                    this.selectedInvoices.push({invoice_id: invoice.id, amount_paid: this.getInvoicePayableAmount(invoice)})
                }
            })
        },

        getInvoicePayableAmount(invoice) {
            return invoice.open_balance > this.availableAmount ? this.availableAmount : invoice.open_balance;
        },

        getInvoicePayingAmount(invoice) {
           return this.selectedInvoices.find((v) => v.invoice_id === invoice.id)?.amount_paid ?? 0;
        },

        isInvoiceSelected(invoice) {
            return this.selectedIds.includes(invoice.id)
        }
    },
    mounted() {
        if (this.child) {
            this.load()
        } else if(this.payment) {
            this.loadPaidInvoices()
        }
        getSpaceCurrency().then(currency => this.currency = currency)
    }
}
</script>

<style scoped>
tbody {
    margin-top: 10px;
}

tr {
    border-style: solid !important;
    border-bottom: 1px #EDF0F3;
}

tr:first-child td {
    padding-top: 0.5rem !important;
}

.invoice-item:hover {
    background-color: #f8f8f8;
    cursor: pointer;
}
</style>
